@if (visible) {
  @if (items && items.length>1) {
    <pub-multi-select [items]="items" [label]="label" [multipleSelect]="multipleSelect"
      [allSelectedLabel]="allSelectedLabel" [logger]="logger"
      [cssClassName]="cssClassName" (selectValues)="onSelectValues($event)"
      [selectedValues]="selectedValues" [required]="!allowAllSelection" data-testid="select"/>
  }
}
